var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.58398C10.0716 2.58398 8.18657 3.15581 6.58319 4.22716C4.97982 5.2985 3.73013 6.82124 2.99218 8.60282C2.25422 10.3844 2.06114 12.3448 2.43735 14.2361C2.81355 16.1274 3.74215 17.8647 5.10571 19.2283C6.46928 20.5918 8.20656 21.5204 10.0979 21.8966C11.9892 22.2728 13.9496 22.0798 15.7312 21.3418C17.5127 20.6039 19.0355 19.3542 20.1068 17.7508C21.1782 16.1474 21.75 14.2624 21.75 12.334C21.7473 9.74896 20.7192 7.2706 18.8913 5.44271C17.0634 3.61482 14.585 2.58671 12 2.58398ZM15.8016 12.9509L10.9266 16.3259C10.814 16.4037 10.6823 16.4492 10.5458 16.4576C10.4092 16.4659 10.2729 16.4368 10.1517 16.3732C10.0306 16.3097 9.92907 16.2142 9.85825 16.0971C9.78744 15.98 9.75001 15.8458 9.75 15.709V8.95898C9.75001 8.82215 9.78744 8.68793 9.85825 8.57085C9.92907 8.45377 10.0306 8.35829 10.1517 8.29475C10.2729 8.23122 10.4092 8.20204 10.5458 8.21039C10.6823 8.21874 10.814 8.26429 10.9266 8.34211L15.8016 11.7171C15.9013 11.7861 15.9829 11.8783 16.0392 11.9857C16.0956 12.0932 16.125 12.2127 16.125 12.334C16.125 12.4553 16.0956 12.5748 16.0392 12.6822C15.9829 12.7897 15.9013 12.8819 15.8016 12.9509Z",
    fill: "#26A65B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaly);
export default __webpack_public_path__ + "static/media/paly.06e8ed212ff4335f647aa312c7d30686.svg";
export { ForwardRef as ReactComponent };